import { Intent } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"
interface AnalyticsCardProps {
  title: string
  value: string | number
  intent?: Intent
}
const AnalyticsCard = ({ title, value, intent }: AnalyticsCardProps) => {
  return (
    <div className={classNames("vt-card")}>
      <h6>{title}</h6>
      <p className={intent && `vt-${intent}`}>{value}</p>
    </div>
  )
}

export default AnalyticsCard
